import { render } from "./DesignSVGArt.vue?vue&type=template&id=b3594f64&scoped=true"
import script from "./DesignSVGArt.vue?vue&type=script&lang=js"
export * from "./DesignSVGArt.vue?vue&type=script&lang=js"

import "./DesignSVGArt.vue?vue&type=style&index=0&id=b3594f64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3594f64"]])

export default __exports__